import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  // { value: 'teu', label: 'Total TEUs'},
  // { value: 'weight', label: 'Total Weight'},
];
export const trendsDropdownOptions = [{ value: "shipments", label: "Shipments", table_header: "Total Shipments" }];
export const defaultData = {
  name: "UK Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  isShipmentGridNew: true,
  isUIGridNew: true,
  isViewAllGridNew: true,
  isUEGridNew: true,
  showUiTrends: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2016-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [{ value: "shipments", label: "Shipments", table_header: "Total Shipments" }],
  apiEndPoints: {
    getArrivalDate: getApiUrl("ukExportLatestArrivalDate"),
    getSearchResult: getApiUrl("ukExportSearch"),
    getAnalyticsData: getApiUrl("analytics/ukExportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_uk_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_uk_exports"),
    getShipmentByID: getApiUrl("ukExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfUkExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/ukExportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.uk_export.country_small,
  countryCaps: globalCountryDetails.uk_export.country_caps,
  product_id: globalCountryDetails.uk_export.product_id,
  compare_product_id: globalCountryDetails.uk_export.compareProduct,
  country_CamelCase: globalCountryDetails.uk_export.product_id,
  countryCode: globalCountryDetails.uk_export.countryCode,
  countryShortHand: globalCountryDetails.uk_export.countryShortHand,
  countryType: globalCountryDetails.uk_export.countryType,
  manyCountryType: globalCountryDetails.uk_export.manyCountryType,
  countryTypeCode: globalCountryDetails.uk_export.countryTypeCode,
  redirectionID: globalCountryDetails.uk_export.redirectionID,
  analyticsCountryID: globalCountryDetails.uk_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipments Arrival Date Range",
  monthRangeHeading: "Month of Export",
  isHandleTrademoAccount: false,
  onboardingText: {
    reacttourDateRange: "Customize your shipment basis payment date",
    reacttourFilterH: "Filters Button",
    reacttourFilterP: "Use filters to get most relevant shipments for you",
    reacttourMainSearchH: "Start searching for UK Exports Shipments",
    reacttourMainSearchP: "HS Codes and Consignees",
    navTabP: "View unique importers in the search result and add them to your prospect list.",
    savedSearchButtonP: "Reload from Saved Searches, for quick shipments data access.",
  },
  picker: {
    monthPicker: true,
    datePicker: false,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: false,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: false,
    product_hscode: true,
    exporters: true,
    importers: false,
    allCategory: true,
  },
  searchCategoryList: globalCountryDetails.uk_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    // consignee: 'importers',
    shipper: "derivedShipperMasterName",
    // weight: 'weight',
    // teu: 'teu',
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
  },
  filterObj: {
    countryOfOrigin: "countryOfOrigin",
    countryOfExport: "countryOfExport",
    shipperName: "shipperName",
    originZipcode: "originZipcode",
    originCity: "originCity",
    hsCode: "hsCode",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    // include_master_bill: 'include_master_bill',
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  localisationFilterObj: {
    // originCityRegion: "originCity",
    // countryOfExportRegion: "countryOfExport",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfOrigin: [],
    countryOfExport: [],
    shipperName: [],
    originZipcode: [],
    originCity: [],
    hsCode: [],
    sections: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    // include_master_bill: true,
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfOrigin: false,
    shipperName: false,
    originZipcode: false,
    countryOfExport: false,
    originCity: false,
    hsCode: false,
    sections: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: categoryType.shipperDetails, eventKey: "16", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: categoryType.shipperDetails, eventKey: "2", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search Shipper Name", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Origin", categoryName: categoryType.shipperDetails, eventKey: "1", key: "countryOfOrigin", type: filterType.normalFilter, label: "Country Of Origin", viewAllPlaceHolder: "Search Country of Origin", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper City", categoryName: categoryType.shipperDetails, eventKey: "3", key: "originCity", type: filterType.normalFilter, label: "Shipper City", viewAllPlaceHolder: "Search Shipper City", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "9", key: "countryOfExport", type: filterType.normalFilter, label: "Country Of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Zip Code", categoryName: categoryType.shipperDetails, eventKey: "4", key: "originZipcode", type: filterType.normalFilter, label: "Shipper Zip Code", viewAllPlaceHolder: "Search Shipper Zip Code", emptyFilterText: "", searchFilterString: "", isTextCapitalise: true },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "5", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Type to Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Type to Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "5", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Type to Search HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: false, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: false, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "shipper_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Name" },
    { key: "derived_shipper_address", label: "Shipper Address" },
    { key: "zipcode", label: "Shipper Zip Code" },
    { key: "derived_city", label: "Shipper City" },
    { key: "hs_code", label: "HS Code" },
    { key: "derived_hs_code", label: "HS Code" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
  ],
  shipmentSorting: [
    { columnKey: "date", value: "date", isDefault: true },
    // { columnKey: 'derived_weight', value: 'weight', isDefault: false },
    // { columnKey: 'derived_shipment_teu', value: 'teu', isDefault: false}
  ],
  exporterSorting: [
    // { columnKey: 'teu', value: 'teu', isDefault: true},
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    // { columnKey: 'weight', value: 'weight', isDefault: false }
  ],
  importerSorting: [
    // { columnKey: 'teu', value: 'teu', isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    // { columnKey: 'weight', value: 'weight', isDefault: false }
  ],
  sortKeyMap: {
    date: "date",
    // weight: 'derived_weight',
    // teu: 'derived_shipment_teu'
  },
  sortKeyUniqueImpExpMap: {
    // teu: 'teu',
    date: "doc_count",
    // weight: 'weight'
  },
  analyticsHeaderItems: [
    { label: "Total Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    // { label: 'Total TEUs', key: 'total_teu', valuePrefix: '', valueSuffix: '', },
    // { label: 'Total Shipments Weight', key: 'total_weight', valueSuffix: 'Kg', valuePrefix: '', },
  ],
  analyticsFieldsMapping: [
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country", filterKey: "countryOfOrigin", label: "Countries of Origin", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_city" },
    { key: "derived_city", filterKey: "originCity", altKey: "originCity", label: "Shipper Cities", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country" },
    { key: "hs_code", headerLabel: "HS Codes", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true },
    { key: "date", name: "Month of Export", selector: "date", dataTip: "", type: "", dateFormat: "MMM, YYYY", sortable: true },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField" },
    { key: "derived_hs_code", name: "HS Code", selector: "derived_hs_code", dataTip: "", type: "" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E" },
    { key: "derived_city", name: "Shipper City", selector: "derived_city", dataTip: "", type: "" },
    { key: "derived_country", name: "Country Of Origin", selector: "derived_country", dataTip: "", type: "" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", isCommaFormat: true },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Month of Export", value: "date", dateFormat: false, monthFormat: true },
        { label: "HS Code", value: "derived_hs_code" },
        // { label: '', value:'master_bol_number', capitalize:true,},
        // { label: '', value:'house_bol_number', capitalize:true,},
        // { label: '', value: 'derived_is_containerised',},
        // { label: 'HS Code', value: 'derived_mode_of_transport_english', isConditionalField: true,
        //     conditionalComponentData:[{
        //         dependentField: 'hs_codes_derived_string',
        //         mappingField: 'hs_code_description_map',
        //         infoText: 'Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.',
        //         isHSCodeFormatter: true,
        //         label: 'HS Code',
        //         isReadMore: true,
        //         readMoreLength: 65,
        //         isThunderIcon: false
        //     },
        //     {
        //         dependentField: 'derived_estimated_hs_code_is_present',
        //         mappingField: 'hs_codes_estimated_description_map',
        //         infoText: 'These HS Code(s) have been estimated based on the shipment data.',
        //         isHSCodeFormatter: true,
        //         label: 'Estimated HS Code',
        //         isReadMore: true,
        //         readMoreLength: 65,
        //         hideField: true,
        //     },
        //     {
        //         dependentField: '',
        //         mappingField: '',
        //         infoText: 'Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.',
        //         isHSCodeFormatter: false,
        //         label: 'HS Code',
        //         isReadMore: false,
        //         readMoreLength: 0,
        //         isThunderIcon: false
        //     }
        // ]},
        // { label: 'Product Keywords', value:'derived_unique_product_keywords', isReadMore:true, readMoreLength:160, capitalize:true, infoText:'Product keywords derived from detailed product description on each shipment.', isProductKeywordFormater: true},
        // { label: 'Estimated Shipment Value', value:'derived_shipment_value', isThunderIcon:true, valuePrefix:"USD ", isCommaFormat:true, fixedValueUpto:2,  infoText:'Shipment Value', hideField: true, },
        // { label: 'TEU', value: 'derived_shipment_teu', isThunderIcon: true, infoText:"Twenty-feet Equivalent Unit", hideField: true,},
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: false,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Origin", value: "derived_country", countryFlag: true, countryCodeField: "derived_country_code" },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper Name", value: "shipper_name" },
        // { label: 'Place of Receipt', value: 'place_of_receipt', infoText: 'City or Country name in which carrier first took possessionof shipment'},
        { label: "Shipper Standardized Name", value: "shipper_name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
        { label: "Shipper Address", value: "derived_shipper_address", isReadMore: true, readMoreLength: 45 },
        { label: "Shipper Zip Code", value: "zipcode" },
        { label: "Shipper City", value: "derived_city" },
        // { label: 'Supplier Name', value: 'shipper_party_name', infoText: 'Name of the company exporting Shipment' },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    // {
    //     id: 3,
    //     title: "Shipment Destination Details",
    //     growValue: 6,
    //     isHeader: false,
    //     isCompactHeader: true,
    //     imgUrl: "",
    //     data: [
    //         { label: 'Port of Unlading', value: 'derived_port_of_unlading', infoText: 'Port where the goods were unloaded from a seagoing vessel.', tooltip: true, tooltipPrefix: 'Port Code: ', tooltipField: 'port_of_unlading' },
    //         { label: 'Port of Destination', value: 'derived_port_of_destination' },
    //         { label: 'Foreign Port of Destination', value: 'foreign_port_of_destination' },
    //         { label: 'Consignee Standardized Name', value: 'consignee_name', type: 'redirect', companyIdKey: 'derived_consignee_master_company_id', companyKey: 'consignee_name', derivedCompanyKey:'derived_consignee_master_name'  },
    //         { label: 'Consignee Name', value: 'consignee_name', infoText: 'Name of the company importing Shipment', isCapitalise: true},
    //         { label: 'Consignee Address', value: 'derived_consignee_full_addr', infoText: 'Address of the importing company' },
    //         { label: 'Consignee City', value: 'derived_consignee_city' },
    //         { label: 'Consignee State', value: 'derived_consignee_state' },
    //         { label: 'Consignee Country', value: 'derived_consignee_country' },
    //         { label: 'Consignee Zip Code', value: 'derived_consignee_zip_code_clean' },
    //         { label: 'Notify Party Name', value: 'notify_party_name' },
    //         { label: 'Notify Party Address', value: 'derived_notify_party_full_addr', infoText: 'Address of the notify party' },
    //         { label: 'Secondary Notify Party', value: 'secondary_notify_party_1', isMultiFieldMapping: true, multiFieldsArr: ["secondary_notify_party_1", "secondary_notify_party_2", "secondary_notify_party_3", "secondary_notify_party_4", "secondary_notify_party_5","secondary_notify_party_6","secondary_notify_party_7","secondary_notify_party_8","secondary_notify_party_9","secondary_notify_party_10"]  },
    //     ]
    // },
    // {
    //     id: 4,
    //     title: "Carrier Details",
    //     growValue: 6,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     data: [
    //         { label: 'Carrier Name', value: 'derived_carrier_name', infoText: 'Carrier Name' },
    //         { label: 'Vessel Name', value: 'vessel_name', infoText: 'Name of ship used for shipment'  },
    //         { label: 'Vessel Country', value: 'vessel_country', countryFlag: true, countryCodeField: 'vessel_country_code' },
    //         { label: 'VOCC', value: 'derived_vocc_name', isThunderIcon: true, infoText: 'Vessel Operating Common Carrier', tooltip: true, tooltipPrefix: 'VOCC Code: ', tooltipField: 'derived_vocc_code', hideField: true },
    //         { label: 'NVOCC', value: 'derived_nvocc_name', isThunderIcon: true, infoText: 'Non Vessel Operating Common Carrier', tooltip: true, tooltipPrefix: 'NVOCC Code: ', tooltipField: 'derived_nvocc_code', hideField: true },
    //     ]
    // },
    // {
    // id: 5,
    // title: "Cargo Details",
    // growValue: 6,
    // isHeader: false,
    // imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
    // data: [
    //     { label: 'HS Code', value: 'hs_code' },
    // { label: 'Quantity', value: 'manifest_quantity', dynamicUnit: true, unitField: 'manifest_unit' },
    // { label: 'Total Weight', infoText: 'Gross weight of shipment', value: 'derived_weight', valueSuffix: ' Kg' },
    // { label: 'Container Load', value: 'derived_container_load', tooltip: true, tooltipField: 'derived_container_load_str', isCapitalise: true, },
    //     ]
    // },
    // {
    //     id: 6,
    //     title: "Container Details",
    //     growValue: 12,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     isContainer: true,
    //     mainKey: 'container_details',
    //     uniqueKey: 'id',
    //     data: [
    //         {
    //             title: "Container Identifiers",
    //             titleKey: '',
    //             isNested: false,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Container Number', value: 'container_number', defaultValue: 'NA' },
    //                 { label: 'Seal Number', value: 'seal_number', defaultValue: 'NA' },
    //                 { label: 'Type of Service', value: 'type_of_service', defaultValue: 'NA' },
    //                 { label: 'Load Status', value: 'load_status', defaultValue: 'NA' },
    //                 { label: 'Marks & Numbers', value: 'marks_and_numbers', defaultValue: 'NA' },
    //                 { label: 'Equipment Desc.', value: 'equipment_description', defaultValue: 'NA' },
    //             ]
    //         },
    //         {
    //             title: "Container Dimension",
    //             titleKey: '',
    //             isNested: false,
    //             isContainerDimension: true,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Length', value: 'length', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Height', value: 'height', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Width', value: 'width', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Type', value: 'type', defaultValue: 'NA' }
    //             ]
    //         },
    //         {
    //             title: "Cargo Description",
    //             titleKey: '',
    //             isNested: true,
    //             nestedKey: "cargo_description_tables",
    //             nestedNumber: 'desc_seq_number',
    //             childData: [
    //                 { label: 'Piece Count', value: 'piece_count', defaultValue: 'NA', dynamicUnit: true, unitField: 'manifest_unit',},
    //                 { label: 'Description', value: 'cargo_description', defaultValue: 'NA', isReadMore: true, readMoreLength: 65,},
    //                 // { label: '', value: 'table', isTable: true, tableHeaderKey: ['HS Code', 'Value (USD)', 'Weight (kg)'], tableContentKey:['hscode', 'value', 'weight'] }
    //             ]
    //         },
    //         {
    //             title: "HAZMAT Sequence",
    //             titleKey: 'hazmat_sequence_number',
    //             isNested: true,
    //             nestedKey: "hazmat_sequence_tables",
    //             nestedNumber: 'hazmat_sequence_number',
    //             childData: [
    //                 { label: 'Sequence Number', value: 'hazmat_sequence_number', defaultValue: 'NA' },
    //                 { label: 'Code', value: 'hazmat_code', defaultValue: 'NA' },
    //                 { label: 'Class', value: 'hazmat_class', defaultValue: 'NA' },
    //                 { label: 'Code Qualifier', value: 'hazmat_code_qualifier', defaultValue: 'NA' },
    //                 { label: 'Contact', value: 'hazmat_contact', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp.', value: 'hazmat_flash_point_temperature', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Negative Ind', value: 'hazmat_flash_point_temperature_negative_ind', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Unit', value: 'hazmat_flash_point_temperature_unit', defaultValue: 'NA' },
    //                 { label: 'Description', value: 'hazmat_description', defaultValue: 'NA' },
    //                 { label: 'Classification', value: 'hazmat_classification', defaultValue: 'NA' },
    //             ]
    //         },
    //     ]
    // },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your shipment basis payment date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for UK Exports Shipments", description: "HS Codes and Consignees", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  defaultUeUiSecondLevelKey: "derived_country",
  twoColumnMapping: {
    // derived_consignee_master_name:"Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    derived_country: "Countries of Origin",
    derived_city: "Shipper Cities",

    six_digit_hs_code: "6 digit HS Codes",
  },
};

const UKExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default UKExportSearch;
